module.exports = __webpack_public_path__ + "img/5.31351da2.png";